import React, { useState } from "react";
import { Button, Tooltip, Form, Input, Grid } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useForm } from "antd/lib/form/Form";
import NetworkCall from "network/networkCall";
import Request from "network/request";

const { TextArea } = Input;

export default function UserFeedback() {
  const [showFeedback, setShowFeedback] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const [form] = useForm();
  const sendFeedbackApi = async (data) => {
    try {
      setBtnLoading(true);
      const res = await NetworkCall.fetch(Request.sendFeedback(data), false);
      form.resetFields();
      setBtnLoading(false);
      setShowFeedback(!showFeedback);
    } catch (error) {
      setBtnLoading(false);
      setShowFeedback(!showFeedback);
    }
  };
  return (
    <>
      <div className="feedback-form-wrap">
        {showFeedback && (
          <div class="feedback-form">
            <h2>
              Feedback Message{" "}
              <i
                class="icon-close-thin"
                onClick={() => {
                  setShowFeedback(!showFeedback);
                  form.resetFields();
                }}
              />
            </h2>
            <p>
              Your feedback is VERY important to us. Tell us what you like and
              more importantly, what you don't like so we can fix it and make
              RESOLVEit the best it can be!!! Remember - this is just day one.
              We have a lot being introduced over the next 60 days. Give us your
              input… please and thank you!
            </p>
            <Form layout="vertical" form={form} onFinish={sendFeedbackApi}>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Please enter feedback!",
                  },
                ]}
                name="content"
              >
                <TextArea
                  rows={4}
                  autoSize={{
                    minRows: 4,
                    maxRows: screens["md"] ? 18 : 12,
                  }}
                />
              </Form.Item>
              <Form.Item className="mb-0 text-right">
                <Button loading={btnLoading} type="primary" htmlType="submit">
                  Send Feedback
                </Button>
              </Form.Item>
            </Form>
          </div>
        )}
        <Tooltip
          placement="topLeft"
          title={"Send Feedback"}
          color="#112D4E"
          // {...(screens["md"]
          //   ? showFeedback
          //     ? { open: false }
          //     : {}
          //   : { open: false })}
        >
          <Button
            shape="circle"
            onClick={() => {
              setShowFeedback(!showFeedback);
              form.resetFields();
            }}
            type="primary"
            size="large"
            className={`btn-form-trigger ${
              showFeedback ? "btn-icon-close" : ""
            }`}
          >
            <i class="icon-message"></i>
            <CloseOutlined />
          </Button>
        </Tooltip>
      </div>
    </>
  );
}
